export default __webpack_public_path__ + "static/media/151-real-estate.57d7cfbb.png";